module.exports = __webpack_public_path__ + "media/images/plug-17461bc51f0495df50742ee170892795.jpg";